import ReviewStarRating from "./modules/ReviewStarRating";
import ReviewBarRating from "./modules/ReviewBarRating";
import ReviewActions from "./modules/ReviewActions";
import domReady from "./util/domReady";

domReady( () => {
  let reviewForm = document.querySelector( '#commentform' );
  if ( ! reviewForm ) {
    window.location = palram.home_url;
    return;
  }

  new ReviewStarRating();
  new ReviewBarRating();
  new ReviewActions();

  reviewForm.addEventListener( 'submit', event => {
    event.preventDefault();
    let input = reviewForm.querySelector( 'input[name="recaptcha"]' );

    if ( input && ! input.value && ! [ wpcf7_recaptcha, grecaptcha ].includes( undefined ) ) {
      grecaptcha.ready( function () {
        grecaptcha.execute( wpcf7_recaptcha.sitekey, { action : 'submit' } ).then( function ( token ) {
          input.value = token;
          reviewForm.submit();
        } );
      } );
    } else {
      reviewForm.submit();
    }
  } );
} );
